import _sortBy from 'lodash-es/sortBy';
import addHours from '@teetsh/app/src/utils/time/addHours';
import isWithinInterval from '@teetsh/app/src/utils/time/isWithinInterval';
import subHours from '@teetsh/app/src/utils/time/subHours';
import { format } from '@teetsh/app/src/utils/time/format';
import { CJEvent, ObjectWithClassrooms } from '@teetsh/app/src/types/event';

export interface AddEvent extends ObjectWithClassrooms {
  id: string;
  type: 'add-event';
  start: Date;
  end: Date;
}

export function computeAddEvents(
  events: CJEvent[],
  classroomIds: string[],
): AddEvent[] {
  if (events.length === 0) {
    return [];
  }
  const minStart = _sortBy(events, e => e.start)[0].start;
  const maxEnd = _sortBy(events, e => -e.end)[0].end;
  const sortedContained = _sortBy(events, e => e.start);
  return sortedContained.reduce(
    (acc, num, index) => {
      const nextItem = sortedContained[index + 1];
      if (nextItem === undefined) {
        return acc;
      }
      const nextItemStart = nextItem.start;
      if (isWithinInterval(nextItemStart, { start: num.start, end: num.end })) {
        return acc;
      }
      return [
        ...acc,
        {
          classroomIds,
          id: format(nextItemStart, 'fr-FR'),
          type: 'add-event',
          start: num.end,
          end: nextItemStart,
        },
      ];
    },
    [
      {
        classroomIds,
        id: format(subHours(minStart, 1), 'fr-FR'),
        type: 'add-event',
        start: subHours(minStart, 1),
        end: minStart,
      },
      {
        classroomIds,
        id: format(maxEnd, 'fr-FR'),
        type: 'add-event',
        start: maxEnd,
        end: addHours(maxEnd, 1),
      },
    ],
  );
}
